import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { CourseService } from '../../../../../core/services/course.service';
import { FileService } from '../../../../../core/services/file.service';
import { PdfService } from '../../../../../core/services/pdf.service';
import { ProfessorAcademicClassroomService } from '../../../../../core/services/professor-academic-classroom.service';
import { ProfessorCourseService } from '../../../../../core/services/professor-course.service';
import { ProfessorService } from '../../../../../core/services/professor.service';
import { ProgramService } from '../../../../../core/services/program.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'app-professor-course',
    templateUrl: './professor-course.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule, NgxExtendedPdfViewerModule],
    styleUrls: ['./professor-course.component.css']
})
export class ProfessorCourseComponent {
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  @ViewChild('contentStudents') contentStudents:TemplateRef<any> | undefined

  buttonsPermission :any|undefined;
 search_text=""
  professors:any[] =[]
  students:any[] =[]
  courses:any[] =[]
  classrooms:any[] =[]
  selectedClassrooms:any[] =[]
  data:any[] =[]
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  cycleId:any
  loading=false
  tag="admin-professors-courses"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  professor_id:any
  fileInput:any
  pdfViewLoader=false
 

  constructor(
    private spinnerService:NgxSpinnerService,
    private paccService:ProfessorCourseService,
    private sacService:StudentAyClassroomService,
    private courseService:CourseService,
    private pdfService:PdfService,
    private professorService:ProfessorAcademicClassroomService,
    private programService:ProgramService,
    private fileService:FileService,
    private toastrService:ToastrService,
    private lsService:LocalStorageService,
    configCanvas: NgbOffcanvasConfig, 
    private offcanvasService: NgbOffcanvas,
      config: NgbModalConfig,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;

     configCanvas.position = 'end';
     configCanvas.backdropClass = 'bg-info';
     configCanvas.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
this.getActions()
  }

  init(){
    this.getAll()
    this.getCourses()
    this.getProfessors()
  
  }


  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des enseignants",err)

    })
  }

  getAll(){
    this.paccService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des enseignants",err)
    })
  }
  getCourses(){
    this.courseService.getAll().subscribe((res:any)=>{
      this.courses=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des enseignants",err)
    })
  }
  getProfessors(){
    this.professorService.getAll().subscribe((res:any)=>{
      this.professors=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des enseignants",err)
    })
  }


  store(form:any){
    this.loading=true
    
    this.paccService.store(form.value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        form.resetForm()
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
  update(value:any){
    this.loading=true

    this.paccService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.paccService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
})
  }

  removeCourse(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.paccService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
    this.professor_id=el.professor?.id
    this.classrooms=this.professors.find((el:any)=> el.id == this.professor_id).pacs

  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }

  getPage(event:any){
    this.pg.p=event
  }


  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }
  addFileContent(content:any){
    if(!this.verifyIfElementChecked()) return ;

    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }
  openForSpeciality(el:any,paccId:any){
    this.spinnerService.show()
    this.sacService.getAll(el.classroom_id).subscribe((res:any)=>{
      this.spinnerService.hide()
      res.data.forEach((element:any) => {
        this.students.push({
          pacc_id:paccId,
          sac_id:el.element.id,
          identity:element.id,
          status:false
        })
      });
      this.offcanvasService.open(this.contentStudents,{  panelClass: 'details-panel', position: 'end'  })
    },
  (err:any)=>{
    this.spinnerService.hide()
    AppErrorShow.showError("Gestion des enseignants",err)

  })
  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.paccService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des enseignants",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }

  async upload(event:any){
    if(event.target.files.length>0){
     this.fileInput=event.target.files[0]
    }
  } 

  loadClassrooms(ev:any){
    console.log(this.professors.find((el:any)=> el.id == ev.target.value))
    this.classrooms=this.professors.find((el:any)=> el.id == ev.target.value).pacs
  }

  
  getPdf(){
    var professors:any[]=[];
    this.data.forEach((el:any)=> professors.push(el.professor?.id));
    this.pdfService.getProfessorCoursesList(professors).subscribe((res:any)=>{
      console.log(res);
      
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });
  },
  (err:any)=>{
    console.log(err)
      AppErrorShow.showError("Gestion des cours",err)

  })
  }
}
